import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import pdfMake from 'pdfmake/build/pdfmake';
import htmlToPdfmake from 'html-to-pdfmake';
import { Subject } from 'rxjs';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import { CommonModule } from '@angular/common';
import { UserDatePipe } from '../../../../../../shared/pipes/user-date.pipe';

@Component({
  selector: 'app-print-graph',
  standalone: true,
  imports: [CommonModule, UserDatePipe],
  templateUrl: './print-graph.component.html',
})
export class PrintGraphComponent implements OnDestroy {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sheetData: any = null;
  /* eslint-disable @typescript-eslint/no-explicit-any */
  @Input() set graphData(val: any) {
    this.sheetData = val;
    this.cd.detectChanges();
    this.initialized = true;
  }
  @ViewChild('pdfContent', { static: true }) pdfContent!: ElementRef;
  initialized = false;
  private readonly destroy$ = new Subject<void>();
  constructor(private readonly cd: ChangeDetectorRef) {}

  async printPDF() {
    if (this.sheetData) {
      const pdfContent = document.getElementById('pdf-data');
      if (pdfContent) {
        const pdfMakeContent = htmlToPdfmake(pdfContent.innerHTML);
        const documentDefinition: TDocumentDefinitions = {
          content: pdfMakeContent,
          pageMargins: [20, 20, 20, 20],
          footer: function (currentPage: number) {
            return {
              columns: [
                { text: '', alignment: 'left' },
                {
                  text: `Powered by Insights to Behavior®`,
                  alignment: 'center',
                },
                { text: `${currentPage}`, alignment: 'right' },
              ],
              margin: [15, 0, 10, 0],
              color: '#475467',
            };
          },
          styles: {
            desc: { fontSize: 12 },
            address: { fontSize: 12 },
            title: { fontSize: 12 },
            datalabel: { color: '#475467' },
            dataValue: { color: '#475467' },
            chartImage: {
              alignment: 'center',
            },
          },
          defaultStyle: {
            columnGap: 10,
            fontSize: 10,
          },
        };

        // Generate and download the PDF
        pdfMake
          .createPdf(documentDefinition)
          .download(
            `${this.sheetData?.caseDetail.student.firstName} ${this.sheetData?.caseDetail.student.lastName}.pdf`
          );

        this.initialized = false;
        this.ngOnDestroy();
      }
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
